// components/PageLoader.tsx
'use client';

import NextTopLoader from 'nextjs-toploader';

const PageLoader: React.FC = () => (
  <NextTopLoader
    color="#1890ff"
    initialPosition={0.08}
    crawlSpeed={200}
    height={3}
    crawl
    showSpinner={false}
    easing="ease"
    speed={500}
    shadow="0 0 10px #1890ff, 0 0 5px #1890ff"
  />
);

export default PageLoader;
